// extracted by mini-css-extract-plugin
export default {"close":"SMLUpgradePromptHead_close__ENWBV","icon":"SMLUpgradePromptHead_icon__cKH80","title":"SMLUpgradePromptHead_title__ppHXx","body":"SMLUpgradePromptHead_body__h7iCI"};